import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Modifies request headers
 */
@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let newReq = request;

    // Only modify headers if we talk to our own API
    if (request.url.startsWith(environment.apiUrl))
    {
      // const headers: { [name: string]: string } = {};
      let headers = request.headers;

      if ((request.method === 'post' || request.method === 'delete') && !(request.body instanceof FormData)) {
        headers = headers.set('Content-Type', 'application/json');
      }

      newReq = request.clone({
        headers
      });
    }

    return next.handle(newReq);
  }
}
